import { useEffect, useState } from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { ThemeButton } from '@shared/ui/buttons';
import { useForm, useWatch } from 'react-hook-form';
import { FormSum } from '@shared/ui/forms/display';
import Note from '@shared/ui/messages/Note';
//todo: удалить
import WalletInputCopy from '@widgets/cards/WalletInputCopy';
import MasterBalance from '@widgets/balance/MasterBalance';
import ChannelsSelect from '@shared/ui/forms/ChannelsSelect';
import { fetchWithdrawChannels } from '@app/store/slices/withdrawChannelsSlice';
import { useSelector, useDispatch } from 'react-redux';
import { BasicInput, AmountInput } from '@shared/ui/forms/inputs';
import { formatBalanceUi } from '@utils/balance-helpers';
import { validateMinAmount, validateServerErrors } from '@utils/validation';
import { useWithdraw } from '@app/api/cards/useWithdraw';

export default function WithdrawDialog({ close, data }) {
  const dispatch = useDispatch();
  const { withdrawChannels } = useSelector((state) => state.withdrawChannels);
  const { user } = useSelector((state) => state.user);
  const { withdraw } = useWithdraw();
  const [loading, setLoading] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      currency: null,
    },
  });

  async function onSubmit(formData) {
    const selectedChannel = withdrawChannels?.find(
      (channel) => channel.id === selectedChannelIdWatch,
    );
    const payload = {
      user_id: user?.id,
      currency: selectedChannel?.currency,
      bank_id: 0,
      wallet: selectedChannel?.address,
      amount: formData?.amount,
    };

    try {
      setLoading(true);
      const res = await withdraw(payload);
      if (res) close();
    } catch (err) {
      validateServerErrors(setError, err);
    } finally {
      setLoading(false);
    }
  }

  const selectedChannelIdWatch = useWatch({
    control,
    name: 'currency',
  });

  const amountWatch = useWatch({
    control,
    name: 'amount',
  });

  const withdrawFee = 0.035;
  const expectedAmount = !amountWatch ? 0 : amountWatch * (1 - withdrawFee);

  useEffect(() => {
    dispatch(fetchWithdrawChannels());
  }, []);

  return (
    <div>
      <DialogContent>
        <MasterBalance />
        <div className="form">
          <ChannelsSelect
            control={control}
            name="currency"
            label="Withdrawal channel"
            close={close}
            error={errors.currency}
          />
          {selectedChannelIdWatch && (
            <BasicInput
              label="Wallet address"
              icon="wallet-input"
              valueProp={
                withdrawChannels?.find(
                  (channel) => channel.id === selectedChannelIdWatch,
                )?.address
              }
            />
          )}
          <div className="formGroup-grid">
            <AmountInput
              control={control}
              name="amount"
              label="Amount"
              hint={`Min 20 $`}
              error={errors.amount}
              isRequired={true}
              validation={validateMinAmount}
              min={20}
              disabled={!withdrawChannels?.length}
            />
            <FormSum
              label="Expected amount"
              text={formatBalanceUi(expectedAmount, 'USD', null, true)}
            />
          </div>
          <Note singleLine type="info" content="Withdrawal fee 3.5%" />
          <Note
            type="warning"
            title="Important"
            content="Make sure your wallet, network and currency are correct to avoid loss of funds. Withdrawals take up to 3 days but usually complete within 30 minutes."
          />
        </div>
      </DialogContent>
      <DialogActions>
        <ThemeButton
          minWidth
          icon="check"
          onClick={handleSubmit(onSubmit)}
          loading={loading}
        >
          Confirm
        </ThemeButton>
      </DialogActions>
    </div>
  );
}
